
import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config';

export async function dispatchAction(id, actionCode, isCarmuv = false, fields) {
  const result = await axios
    .put(
      `${REACT_APP_API}/dispatch-actions?action_code=${actionCode}&id=${id}&is_carmuv=${isCarmuv}`, { fields }
    )

  return result?.data
}
